import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/locale/fr';
import {truncateText} from '../../../../app/utils/text';
import {withLocalize} from 'react-localize-redux';
import AddIcon from '@material-ui/icons/Add';

class NewsListItem extends Component {
    render() {
        const {news} = this.props;

        moment.locale('fr');

        const uri = this.props.translate('routes.news_details').replace(':slug', news.slug);

        const dateFormat = 'D MMM YY';
        const date = moment(news.date, 'YYYY-MM-DD').format(dateFormat);

        return (
            <div className="col-lg-3 col-md-6 col-sm-12" key={news.id}>
                <Link to={uri} className="item">
                    <div className="inner">
                        <div className="top">
                            <div className='dates'>
                                {/*ReactHtmlParser(date)*/}
                            </div>
                        </div>
                        <div className="title">
                            {ReactHtmlParser(truncateText(news.title, 60))}
                        </div>
                        <div className="excerpt">
                            {ReactHtmlParser(truncateText(news.excerpt, 50))}
                        </div>
                        <div className="bottom">
                            <span className="btn-more"><AddIcon className="m-icon" /></span>
                        </div>
                    </div>
                </Link>
            </div>
        );
    }
}

NewsListItem.propTypes = {
    news: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(NewsListItem);


// WEBPACK FOOTER //
// ./src/features/News/components/List/NewsListItem.js